import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';

import axios from 'axios'
import { Recommendations, RecommendationSummary } from './Recommendations';
import Feedback from './Feedback';
import { API_BASE_PATH } from './Api';

function CrossSellRaw({recommendations}){

  const ulStyle = { width: '100%', listStyleType: 'none',padding:'0px' }
  const liStyle = { color: 'black', fontSize: '16px', borderBottom: '1px solid #eee',padding:'10px',margin:"10px" }

  return(
    <ul style={ulStyle}>
        {
          recommendations && recommendations.skuInfo && 
          
          Object.keys(recommendations.skuInfo).map((key)=>(
            <li style={liStyle}>

                <table className="cattable">
              <tr><th>SKU</th><th>Quantity</th></tr>
              <tr><td>{key}</td><td>{recommendations.skuInfo[`${key}`]}</td></tr>

            </table>
              </li>
            
        ))
          
        }   
        
      </ul>
  );
}

export default function Crosssell() {

  var userInfo = localStorage.getItem("userInfo");
  if(userInfo){
    userInfo = JSON.parse(userInfo);
  }

  const getOutletInfo = async () => new Promise((res, rej) => {
    axios.get('http://localhost:8080/crosssell_marsinduat.json')
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });

  const getRecommendations = async (outletCode) => new Promise((res, rej) => {
    axios.get(API_BASE_PATH+`/objects/crossSell2/outletCode/${outletCode}?lob=${userInfo.accountId}`)
      .then(response => {
        const data = response.data;
        res(data)
      })
      .catch(error => {
        console.log(error);
      })
  });


  




  const [value, setValue] = useState({value:"x"});
  const [items, setItems] = useState(['one', 'two', 'three']);
  const [outlets, setOutlets] = useState([]);

  const [recommendations, setRecommendations] = useState([]);
  const [data, setData] = useState({});

  const [clusterInfo, setClusterInfo] = useState({});
  const [recordInfo, setRecordInfo] = useState({});
  const [outletClusters, setOutletClusters] = useState([]);

  const [loading, setLoading] = useState(false);
  const [statusInfo, setStatusInfo] = useState({});

  useEffect(() => {
    getOutletInfo()
      .then(data => {
        const outs1 = [];
        const outs = [];
        const dMap=[];
        for(var k=0;k<data.length;k++){
            var ocode = data[k].outletCode+"-"+data[k].user;
            outs1[ocode]={ label: ocode, value: ocode,id:data[k].id }
            dMap[ocode]=data[k];
        }
        for(var k in outs1){
            outs.push(outs1[k]);

        }
        
        setData(dMap);
        setOutlets(outs);
      }
      );

      // getClusterInfo()
      // .then(data => {
      //   setClusterInfo(data);
      //   let oc = []; 
      //   data.records.forEach(element => {
      //     oc[element.key]=element;
      //   });
      //   setOutletClusters(oc)
      // }
      // );
  }, [])

  const handleChange = (e) => {
    console.log(e)
    setValue(e);
    items.push(e.value);
    setItems(items);
    setLoading(true);
    setRecommendations({skuInfo:{}});
    console.log(data[e.value])
    const str=e.value.split("-");
    getRecommendations(str[0]).then(recs=>{
      var isFound=false;

      recs.forEach(element => {

        if(str[1] && element.key2==str[1]){
          setRecommendations(element.payload);
          isFound=true;
          setStatusInfo({type:"crosssell",status:element.payload.status,category:element.payload.category,id:element.id,message:element.payload.message,verifiedBy:element.payload.verifiedBy})
        }
      });
      if(!isFound){
        setRecommendations({skuInfo:{}});
        setStatusInfo({type:"crosssell"})

      }
      setLoading(false);
    });
    
    // setRecommendations(data[e.value])
    setRecordInfo(outletClusters[e.value])
  };

  const handleInputChange = value => {
    setValue(value);
  };

  const loadOptions = (inputValue) => {
    console.log("Initial value=>"+inputValue+outlets.length)
    if(!inputValue){
      console.log("Sending default")
      return Promise.resolve(outlets.slice(0,50));
    }  
    //return fetch(`http://jsonplaceholder.typicode.com/posts?userId=${inputValue}`).then(res => res.json());
    return Promise.resolve(outlets.filter(x=>x.value.indexOf(inputValue)!=-1).slice(0,50));
  };

  return (
    <div className="container mainPanel" >

<div className="row">
<div className="col-md-8 leftPaner" >

      <br></br>

     
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6">
          {/* <Select
            value={value}
            onChange={handleChange}
            options={outlets}
          /> */}

<AsyncSelect
        
        defaultOptions={outlets.slice(0,50)}
        getOptionLabel={e =>e.value}
        getOptionValue={e => e.value}
        loadOptions={loadOptions}
        // onInputChange={handleInputChange}
        onChange={handleChange}
      />
        </div>
       
        <div className="col-md-4"></div>
      </div>
      <br></br>
      {
        loading && <h2 style={{margin:"auto",textAlign:"center"}}>Operation In Progress...........</h2>
      }
      <div className="row" >

      {recommendations &&  <CrossSellRaw recommendations={recommendations}  />}

        
        
      </div>
      </div>
      <div className="col-md-4 rightPanel">
       {statusInfo &&   <Feedback selectedItem={value} statusInfo={statusInfo} updater={setStatusInfo} loading={setLoading} />}
          </div>

</div>
    </div>
  );
}

